import { Pipe, PipeTransform, inject } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({ name: 'decimalValue' })
export class DecimalValuePipe implements PipeTransform {
  private readonly decimalPipe = inject(DecimalPipe);

  transform(value: number): string {
    return this.decimalPipe.transform(value, '1.2-2');
  }
}
